export const HomepageApi = {
  usefulResources: '/useful-resources',
  regions: '/information/district',
};
